module.exports = __webpack_public_path__ + "img/20190601135224107.667ebca9.png";